import { AppThunk } from "../store";
import { setCities, setCounties, setStates } from ".";
import { setGeolocation } from ".";
import { stateService } from "services/stateService";
import { countyService } from "services/countyService";
import { cityService } from "services/cityService";
import { ServiceOptions } from "services/baseService";

const iLikeQueryFormatter = (name: string) => `%${name.replace(/ /g, "%")}%`;
export const getStatesAsFilterOptions =
  (name?: string): AppThunk =>
  async (dispatch) => {
    try {
      const formattedName = iLikeQueryFormatter(name || "");
      const statesFilters: ServiceOptions = {
        order: [["name", "ASC"] as [string, "ASC"]],
        where: {
          name: {
            $iLike: formattedName,
          },
        },
        limit: 6,
      };
      const { data } = await stateService.getAll(statesFilters);
      dispatch(setStates(data));
    } catch (error) {}
  };

export const getCountiesAsFilterOptions =
  (stateId: number = 15, name?: string): AppThunk =>
  async (dispatch) => {
    try {
      const formattedName = iLikeQueryFormatter(name || "");
      const countiesFilters: ServiceOptions = {
        order: [["name", "ASC"] as [string, "ASC"]],
        where: {
          name: {
            $iLike: formattedName,
          },
          stateId,
        },
        limit: 6,
      };
      const { data } = await countyService.getAll(countiesFilters);
      dispatch(setCounties(data));
    } catch (error) {}
  };

export const getCitiesAsFilterOptions =
  (countyId: number = 1, name?: string): AppThunk =>
  async (dispatch) => {
    try {
      const formattedName = iLikeQueryFormatter(name || "");
      const citiesFilters: ServiceOptions = {
        order: [["name", "ASC"] as [string, "ASC"]],
        where: {
          name: {
            $iLike: formattedName,
          },
          countyId,
        },
        limit: 6,
      };
      const { data } = await cityService.getAll(citiesFilters);
      dispatch(setCities(data));
    } catch (error) {}
  };
export const getGeolocation =
  (address: string): AppThunk =>
  async (dispatch) => {
    try {
      const { data } = await stateService.getGeolocation(address);

      dispatch(setGeolocation(data));
    } catch (error) {}
  };
